import { useLocation } from "react-router-dom";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
import { useOnboardingFlags } from "@/react/hooks/useOnboardingFlags";
import { useUrlParamEnabled } from "@/react/hooks/utils/useUrlParamEnabled";
import { usePunditUserContext } from "@circle-react/contexts";

export const useWorkflowsSplashScreen = () => {
  const { pathname } = useLocation();
  const { onboardingFlags } = usePunditUserContext();
  const { enableFlag, isUpdating } = useOnboardingFlags({
    onEnableFlagSuccess: () => {},
  });

  // Temporary to be removed with launch
  const isWorkflowsSplashScreenURLParamEnabled = useUrlParamEnabled(
    "workflows_splash_screen",
  );

  const shouldShowWorkflowsSplashScreen =
    !onboardingFlags?.workflows_splash_screen_seen &&
    isWorkflowsSplashScreenURLParamEnabled;

  const markWorkflowsSplashScreenAsSeen = () => {
    enableFlag("workflows_splash_screen_seen");
  };

  const isWorkflowsRoute = pathname.includes(settingsNavPathV3.workflows.all);
  const shouldHideWorkflowsNestedNavigation =
    isWorkflowsRoute && shouldShowWorkflowsSplashScreen;

  return {
    markWorkflowsSplashScreenAsSeen,
    isLoading: isUpdating,
    shouldShowWorkflowsSplashScreen,
    shouldHideWorkflowsNestedNavigation,
  };
};
